module.exports = __webpack_public_path__ + "static/media/preview_time.faf45cc6.svg";